export default "__VITE_ASSET__CYNsDEc1__"